import { captureEvent } from '@lib/observability/events/captureEvent';
import 'client-only';

import { FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS } from './constants';
import type {
  DocumentUploadFailureContext,
  DocumentUploadTelemetryContext,
} from './types';

function toAnalyticsProperties(context: DocumentUploadTelemetryContext) {
  return {
    source: context.source,
    deal_id: context.dealId,
    package_id: context.packageId,
    flow_id: context.flowId,
    file_count: context.fileCount,
    total_bytes: context.totalBytes,
    pathname: context.pathname,
    file_names: context.files.map(file => file.name),
    file_sizes_bytes: context.files.map(file => file.sizeBytes),
  };
}

export function trackDocumentUploadStarted(
  context: DocumentUploadTelemetryContext
): void {
  captureEvent(
    FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS.STARTED,
    toAnalyticsProperties(context)
  );
}

export function trackDocumentUploadSucceeded(
  context: DocumentUploadTelemetryContext & { flowId: string }
): void {
  captureEvent(FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS.SUCCEEDED, {
    ...toAnalyticsProperties(context),
    flow_id: context.flowId,
  });
}

export function trackDocumentUploadFailed(
  context: DocumentUploadFailureContext & {
    errorClass?: string;
    collectionId?: string;
    processingAttemptId?: string | null;
    hadStorageDocumentId?: boolean;
  }
): void {
  captureEvent(FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS.FAILED, {
    ...toAnalyticsProperties(context),
    http_status: context.httpStatus,
    failure_phase: context.failurePhase,
    error_message: context.errorMessage,
    ...(context.errorClass ? { error_class: context.errorClass } : {}),
    ...(context.collectionId ? { collection_id: context.collectionId } : {}),
    ...(context.processingAttemptId != null
      ? { processing_attempt_id: context.processingAttemptId }
      : {}),
    ...(context.hadStorageDocumentId != null
      ? { had_storage_document_id: context.hadStorageDocumentId }
      : {}),
  });
}

export function trackFlowProcessingSoftGateFailOpenClient(args: {
  flowId?: string | null;
  collectionId: string;
  processingAttemptId?: string | null;
  missingStorageDocumentId: boolean;
  failOpenMs: number;
}): void {
  captureEvent(
    FLOW_DOCUMENT_UPLOAD_ANALYTICS_EVENTS.PROCESSING_SOFT_GATE_FAIL_OPEN,
    {
      flow_id: args.flowId ?? null,
      collection_id: args.collectionId,
      processing_attempt_id: args.processingAttemptId ?? null,
      missing_storage_document_id: args.missingStorageDocumentId,
      fail_open_ms: args.failOpenMs,
    }
  );
}
